import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next/src/index';
import ShortId from 'shortid';
import Phase from '@hobs/components/Phase';
import Styles from './Submenu.module.scss';

const Submenu = ({ left, right, t }) => {
  return (
    <nav className={Styles.submenu}>
      <div className={Styles.main}>
        <div className={Styles['link-container']}>
          {left &&
            left.map(item => {
              return (
                <NavLink
                  key={ShortId.generate()}
                  exact
                  to={item.link}
                  activeClassName={Styles['active-link']}
                >
                  {t(item.name)}
                </NavLink>
              );
            })}
        </div>
        {right && (
          <Phase
            phases={right.phaseTypes}
            remainingDays={right.remainingDays}
            currentPhase={right.phaseName}
            hideRemainingInfo={right.hide}
          />
        )}
      </div>
    </nav>
  );
};

Submenu.propTypes = {
  left: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  right: PropTypes.object,
  t: PropTypes.func
};

export default connect()(withTranslation()(Submenu));
